import React from 'react';

export function useChatRouteState(pathname?: string) {
  const chatIdFromUrl = React.useMemo(() => {
    const p = pathname || window.location.pathname;
    const uuidPattern =
      /\/ai-tools\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/;
    const aiToolsMatch = p.match(uuidPattern);
    if (aiToolsMatch) return aiToolsMatch[1];
    const fileChatMatch = p.match(
      /\/files\/[^/]+\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/?$/,
    );
    return fileChatMatch ? fileChatMatch[1] : null;
  }, [pathname]);

  const isFileOpen = React.useMemo(() => {
    const p = pathname || window.location.pathname;
    return p.includes('/files/');
  }, [pathname]);

  return { chatIdFromUrl, isFileOpen };
}
